import api from "./index";
import { ENDPOINTS } from "./endpoints";

/* LIST */
export const listSellerProducts = (data) =>
  api.post(ENDPOINTS.SELLER_PRODUCTS.PRODUCTS_SEARCH, data);

/* CREATE */
export const createSellerProduct = (data) =>
  api.post(ENDPOINTS.SELLER_PRODUCTS.PRODUCTS_CREATE, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });

/* DELETE */
export const deleteSellerProduct = (id) =>
  api.delete(ENDPOINTS.SELLER_PRODUCTS.PRODUCTS_DELETE(id));

/* 🔥 GET MASTER PRODUCT SPECS (UPDATED) */
export const getMasterProductSpecs = (master_product_id) =>
  api.get(ENDPOINTS.SELLER_PRODUCTS.MASTER_PRODUCT_SPECS(master_product_id));

/* GET SINGLE */
export const getSellerProductById = (id) =>
  api.get(ENDPOINTS.SELLER_PRODUCTS.PRODUCT_BY_ID(id));

/* UPDATE */
export const updateSellerProduct = (id,data) =>
  api.put(ENDPOINTS.SELLER_PRODUCTS.PRODUCT_UPDATE(id), data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });